import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, X } from 'lucide-react';

const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'gl', name: 'Galego', flag: '🏳️' },
  { code: 'ca', name: 'Català', flag: '🏳️' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }
];

export default function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const [showPanel, setShowPanel] = useState(false);

  const currentLanguage = languages.find(l => l.code === i18n.language) || languages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    setShowPanel(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowPanel(!showPanel)}
        data-testid="language-selector"
        className="rounded-full border-2 border-[#18181B] dark:border-zinc-600 bg-white dark:bg-zinc-800 p-2 hover:bg-zinc-100 dark:hover:bg-zinc-700 hover:shadow-[2px_2px_0px_0px_rgba(24,24,27,1)] transition-all flex items-center gap-1"
        title={t('language.select')}
      >
        <Globe className="w-5 h-5 text-zinc-900 dark:text-white" />
        <span className="text-sm font-bold hidden xs:inline">{currentLanguage.flag}</span>
      </button>

      {showPanel && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowPanel(false)}
          />
          <div 
            className="fixed sm:absolute inset-x-0 bottom-0 sm:inset-auto sm:right-0 sm:top-full sm:mt-2 sm:w-48 bg-white dark:bg-zinc-800 border-t-2 sm:border-2 border-[#18181B] dark:border-zinc-600 rounded-t-2xl sm:rounded-xl hard-shadow z-50 overflow-hidden"
            data-testid="language-panel"
          >
            <div className="p-3 border-b-2 border-[#18181B] dark:border-zinc-600 flex items-center justify-between sm:hidden">
              <h3 className="font-bold text-sm text-zinc-900 dark:text-white">{t('language.select')}</h3>
              <button
                onClick={() => setShowPanel(false)}
                className="p-1 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-700"
              >
                <X className="w-4 h-4 text-zinc-900 dark:text-white" />
              </button>
            </div>
            <div className="py-1">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  data-testid={`lang-${lang.code}`}
                  className={`w-full px-4 py-3 sm:py-2 text-left hover:bg-zinc-100 dark:hover:bg-zinc-700 transition-colors flex items-center gap-3 ${
                    i18n.language === lang.code ? 'bg-[#ADE498]/30 dark:bg-[#ADE498]/20 font-bold' : ''
                  }`}
                >
                  <span className="text-lg">{lang.flag}</span>
                  <span className="text-sm text-zinc-900 dark:text-white">{lang.name}</span>
                  {i18n.language === lang.code && (
                    <span className="ml-auto text-[#ADE498]">✓</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
